import type { TransportItem } from '@grafana/faro-web-sdk'

export type { TransportItem } from '@grafana/faro-web-sdk'

export interface ObservabilityClientConfig {
    /** Collector endpoint URL */
    collectorUrl: string
    app: {
        name: string
        version: string
        environment: string
        namespace: string
    }
    /** Optional filter before sending data to collector. Return null to drop the item. */
    beforeSend?: (item: TransportItem) => TransportItem | null
    /**
     * Cross-origin API URLs that receive a `traceparent` header, so a browser
     * trace joins the server trace. Same-origin requests propagate already.
     */
    tracedApiUrls?: (string | RegExp)[]
}

export interface ObservabilityServerConfig {
    serviceName: string
    serviceVersion: string
    serviceNamespace: string
    deploymentEnvironment: string
    /** Telemetry export endpoint (enables log export when set) */
    exporterEndpoint?: string
    /** Raw comma-separated key=value auth headers for the exporter */
    exporterHeaders?: string
}

export type LogContext = Record<string, string>

export enum LogLevel {
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error'
}

export interface ObservabilityMethods {
    logWarning: (message: string, context?: LogContext) => void
    logError: (message: string, context?: LogContext) => void
    logMeasurement: (type: string, values: Record<string, number>, context?: LogContext, level?: LogLevel) => void
}
